import { render, staticRenderFns } from "./SelectFriendsDialog.vue?vue&type=template&id=ccfe64c2&scoped=true&"
import script from "./SelectFriendsDialog.vue?vue&type=script&lang=js&"
export * from "./SelectFriendsDialog.vue?vue&type=script&lang=js&"
import style0 from "./SelectFriendsDialog.vue?vue&type=style&index=0&id=ccfe64c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccfe64c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\other\\DaMou-Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ccfe64c2')) {
      api.createRecord('ccfe64c2', component.options)
    } else {
      api.reload('ccfe64c2', component.options)
    }
    module.hot.accept("./SelectFriendsDialog.vue?vue&type=template&id=ccfe64c2&scoped=true&", function () {
      api.rerender('ccfe64c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/雙人合盤/SelectFriendsDialog.vue"
export default component.exports